(() => {
  const KEY = 'strengthlab-color-mode';
  const root = document.documentElement;
  const media = window.matchMedia('(prefers-color-scheme: dark)');
  const labels = { system: 'System', light: 'Hell', dark: 'Dunkel' };
  const readStored = () => {
    try {
      const value = localStorage.getItem(KEY);
      return labels[value] ? value : null;
    } catch (_) {
      return null;
    }
  };
  let current = readStored() || root.dataset.slMode || 'system';
  let menu;
  let toggle;

  const resolved = (mode) => mode === 'system' ? (media.matches ? 'dark' : 'light') : mode;
  const store = (mode) => { try { localStorage.setItem(KEY, mode); } catch (_) {} };

  function apply(mode, persist = true) {
    if (!labels[mode]) mode = 'system';
    current = mode;
    root.dataset.slMode = mode;
    root.dataset.slTheme = resolved(mode);
    root.style.colorScheme = resolved(mode);
    if (persist) store(mode);
    document.querySelectorAll('.sl-theme-header-menu__option').forEach((button) => {
      button.setAttribute('aria-checked', String(button.dataset.mode === mode));
    });
  }

  function closeMenu() {
    if (!menu || !toggle) return;
    menu.hidden = true;
    toggle.setAttribute('aria-expanded', 'false');
  }

  function mount() {
    if (document.querySelector('.sl-theme-header-menu')) return;
    const preferredTarget = document.querySelector('.header-actions, .header__icons, .header__column--right, header-component');
    const target = preferredTarget || document.querySelector('#header-group') || document.body;
    const selector = document.createElement('div');
    selector.className = 'sl-theme-header-menu' + (preferredTarget ? '' : ' sl-theme-header-menu--fallback');
    selector.innerHTML = '<button class="sl-theme-header-menu__toggle" type="button" aria-label="Design auswählen" aria-haspopup="true" aria-expanded="false">•••</button><div class="sl-theme-header-menu__menu" role="radiogroup" aria-label="Farbschema" hidden><button class="sl-theme-header-menu__option" type="button" role="radio" data-mode="system">System</button><button class="sl-theme-header-menu__option" type="button" role="radio" data-mode="light">Hell</button><button class="sl-theme-header-menu__option" type="button" role="radio" data-mode="dark">Dunkel</button></div>';
    target.appendChild(selector);
    toggle = selector.querySelector('.sl-theme-header-menu__toggle');
    menu = selector.querySelector('.sl-theme-header-menu__menu');
    toggle.addEventListener('click', () => {
      menu.hidden = !menu.hidden;
      toggle.setAttribute('aria-expanded', String(!menu.hidden));
    });
    selector.querySelectorAll('.sl-theme-header-menu__option').forEach((button) => {
      button.addEventListener('click', () => { apply(button.dataset.mode); closeMenu(); });
    });
    document.addEventListener('click', (event) => { if (!selector.contains(event.target)) closeMenu(); });
    document.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeMenu(); });
    apply(readStored() || current, false);
  }

  const style = document.createElement('style');
  style.textContent = '.sl-theme-header-menu{position:relative;display:inline-flex;align-items:center;margin-inline-start:4px;z-index:110}.sl-theme-header-menu--fallback{position:fixed;top:12px;right:12px}.sl-theme-header-menu__toggle{display:grid;place-items:center;width:36px;height:36px;padding:0;border:1px solid rgba(127,127,127,.25);border-radius:999px;background:rgba(16,16,16,.76);color:#fff;font-size:13px;font-weight:800;letter-spacing:1px;line-height:1;cursor:pointer;backdrop-filter:blur(12px)}.sl-theme-header-menu__toggle:hover{background:#111}.sl-theme-header-menu__menu{position:absolute;right:0;top:calc(100% + 8px);display:grid;min-width:136px;padding:6px;border:1px solid rgba(255,255,255,.14);border-radius:12px;background:rgba(16,16,16,.96);box-shadow:0 12px 28px rgba(0,0,0,.24)}.sl-theme-header-menu__menu[hidden]{display:none!important}.sl-theme-header-menu__option{min-height:34px;padding:0 10px;border:0;border-radius:8px;background:transparent;color:#fff;text-align:left;cursor:pointer;font-size:12px;font-weight:800}.sl-theme-header-menu__option:hover,.sl-theme-header-menu__option[aria-checked=true]{background:rgba(231,255,56,.14);color:#e7ff38}html[data-sl-theme=light] .sl-theme-header-menu__toggle{background:rgba(255,255,255,.9);color:#111;border-color:rgba(17,17,17,.18)}html[data-sl-theme=light] .slx-tile h1,html[data-sl-theme=light] .slx-tile h2,html[data-sl-theme=light] .slx-tile h3,html[data-sl-theme=light] .slx-tile p,html[data-sl-theme=light] .slx-promo h3,html[data-sl-theme=light] .slx-promo p{color:#fff!important;text-shadow:0 2px 18px rgba(0,0,0,.28)}html[data-sl-theme=light] .slx-tile .slx-kicker,html[data-sl-theme=light] .slx-promo .slx-kicker{color:#e7ff38!important;text-shadow:none}';
  document.head.appendChild(style);

  apply(current, false);
  if (media.addEventListener) media.addEventListener('change', () => { if (current === 'system') apply('system', false); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount); else mount();
})();
